import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import EmployeesSlice from "./EmployeesSlice";
import IssueSlice from "./IssueSlice";
import HomeSlice from "./HomeSlice";
import SharedSlice from "./SharedSlice";
import FormsAndTemplatesSlice from "./FormsAndTemplatesSlice";
import StatisticsSlice from "./StatisticsSlice";
import AccountingSlice from "./AccountingSlice";

export default configureStore({
  reducer: {
    AuthSlice,
    EmployeesSlice,
    IssueSlice,
    HomeSlice,
    SharedSlice,
    FormsAndTemplatesSlice,
    StatisticsSlice,
    AccountingSlice,
  },
});
